import moment from 'moment';
import { Axios } from './../shared/Axios';
import qs from 'qs';
import { saveAs } from "file-saver";

class MemberService extends Axios {

    private static instance: MemberService;

    static get(): MemberService {
        if (!MemberService.instance) {
            MemberService.instance = new MemberService();
        }
        return MemberService.instance;
    }

    async getMembers(data: object): Promise<any> {
        return this.instance.get(`/admin/member${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async getMember(member_id: number): Promise<any> {
        return this.instance.get(`/admin/member/${member_id}`)
    }

    async deleteMember(memberId: string): Promise<any> {
        return this.instance.delete(`/admin/member/${memberId}`)
    }

    async getReferrals(data: object): Promise<any> {
        return this.instance.get(`/admin/member/referral${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async getMemberPaymentTransactions(data: object): Promise<any> {
        return this.instance.get(`/admin/member/payment/transaction${qs.stringify(data, { addQueryPrefix: true })}`)
    }


    async getCustomerLevelConfig(data: object): Promise<any> {
        return this.instance.get(`/admin/member/master${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async deleteCustomerLevelConfig(id: string): Promise<any> {
        return this.instance.delete(`/admin/member/master/${id}`)
    }

    async updateCustomerLevelConfig(data: object, id: number): Promise<any> {
        return this.instance.patch(`/admin/member/master/${id}`, data)
    }

    async saveCustomerLevelConfig(data: object): Promise<any> {
        return this.instance.post(`/admin/member/master`, data)
    }

    async saveCustomerLevelBenefitConfig(data: object): Promise<any> {
        return this.instance.post(`/admin/member/master/benefit`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async deleteCustomerLevelBenefitConfig(id: string): Promise<any> {
        return this.instance.delete(`/admin/member/master/benefit/${id}`)
    }

    async getCustomerLevelReward(data: object): Promise<any> {
        return this.instance.get(`/admin/member/reward${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async saveCustomerLevelReward(data: object): Promise<any> {
        return this.instance.post(`/admin/member/reward`, data)
    }

    async deleteCustomerLevelReward(customer_level_reward_id: number): Promise<any> {
        return this.instance.delete(`/admin/member/reward/${customer_level_reward_id}`)
    }


    async exportUsers(data: object): Promise<any> {

        const response : any = await this.instance.get(`/admin/member/export${qs.stringify(data, { addQueryPrefix: true })}`, {
            responseType: "arraybuffer"
        })
        // Create a Blob from the response data
        const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        // Save the file using FileSaver
        saveAs(blob, `Report_${moment().format('DD-MM-YYYY_HH:mm')}.xlsx`);

        return response;


    }

}


const memberService = MemberService.get();

export { memberService as MemberService }